export const objectToQueryString = (object: any, includeSeparator = true) => {
  if (!object) return
  return `${includeSeparator && '?'}${new URLSearchParams(object).toString()}`
}
